"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HelpModal = require("./HelpModal");
Object.keys(_HelpModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HelpModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HelpModal[key];
    }
  });
});